import { api } from './client'

export interface TaskSummary {
  id: string
  title: string
  epic: string
  status: string
  verdict: string | null
  tests: string | null
  note: string | null
  followUps: string[]
}

export interface TaskCard {
  id: string
  markdown: string
}

export const implementationStatusApi = {
  list: () => api<TaskSummary[]>('/api/implementation-status/tasks'),
  getCard: (id: string) =>
    api<TaskCard>(`/api/implementation-status/tasks/${encodeURIComponent(id)}`),
}
